<template>
    <v-toolbar
            id="core-toolbar"
            flat
            style="background: #eee;">
        <div class="v-toolbar-title">
            <v-toolbar-title
                    class="tertiary--text font-weight-light">
                <a href="/">{{title}}</a>
            </v-toolbar-title>
        </div>
        <v-spacer/>
        <v-toolbar-items>
            <v-flex
                    align-center
                    layout
                    py-2>
                <v-menu
                        bottom
                        left
                        content-class="dropdown-menu"
                        offset-y
                        transition="slide-y-transition">
                    <router-link
                            v-ripple
                            slot="activator"
                            class="toolbar-items"
                            to="/notifications">
                        <v-avatar
                                :size="32.0"
                                color="grey lighten-4"
                                class="ml-4 mr-2 avatar">
                            <img src="/static/img/avatar.png"/>
                        </v-avatar>
                        <h4>{{email}}</h4>
                    </router-link>
                    <v-card>
                        <v-list dense>
                            <v-list-tile v-on:click="logout">
                                <v-list-tile-title class="text-xs-center">
                                    <b style="font-size: 15px">Đăng xuất</b>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-menu>
            </v-flex>
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
    export default {
        data: () => ({
            title: 'Survey Add-ons',
            responsive: false,
            responsiveInput: false,
            email: ''
        }),
        mounted() {
            this.email = this.$cookies.get('email').replace(/"/g, "")
            this.onResponsiveInverted()
            window.addEventListener('resize', this.onResponsiveInverted)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResponsiveInverted)
        },

        methods: {
            onClickBtn() {
                this.setDrawer(!this.$store.state.app.drawer)
            },
            logout: function () {
                window.location.href = '/logout/'
            },
            onResponsiveInverted() {
                if (window.innerWidth < 991) {
                    this.responsive = true
                    this.responsiveInput = false
                } else {
                    this.responsive = false
                    this.responsiveInput = true
                }
            }
        }
    }
</script>

<style>
    #core-toolbar a {
        text-decoration: none;
    }
</style>
